import { render, staticRenderFns } from "./StatDistributionCharts.vue?vue&type=template&id=ea9d9ed8&"
import script from "./StatDistributionCharts.vue?vue&type=script&lang=ts&"
export * from "./StatDistributionCharts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports